import {
  registerDestinationAliases,
  registerStationPlaces,
  stationPlacesRegistered,
} from "./place-resolver";

/**
 * 한국 지하철역 사전(stations-kr.generated, 956역 · ~161KB)을 필요할 때 받아
 * place-resolver 에 등록한다.
 *
 * 왜 지연 로드인가: 검색바(useSearchComposer → composer → place-resolver)가 Navbar 에
 * 있어 정적 import 면 사전 전체가 모든 페이지 공용 번들에 실렸다(감사 06 #2). 역 이름은
 * 사용자가 검색할 때만 필요하다.
 *
 * 사용처
 *  - 검색바: 유휴 시간에 미리 받고(preloadSearchPanels), 제출 직전에 await 한다.
 *  - 위치 패널: 마운트 시 받고, 다 받으면 제안을 다시 계산한다.
 *  - 서버·검색 페이지: `@/lib/search/station-places.eager` 를 import 해 즉시 등록한다.
 */
let pending: Promise<void> | null = null;

export function ensureStationPlaces(): Promise<void> {
  if (stationPlacesRegistered()) return Promise.resolve();
  // 여행지 별칭(destination-aliases.generated, 10-19)도 같은 청크 시점에 받는다.
  pending ??= Promise.all([
    import("@/config/search-places/stations-kr.generated"),
    import("@/config/search-places/destination-aliases.generated"),
  ])
    .then(([stations, destinations]) => {
      registerDestinationAliases(destinations.DESTINATION_ALIASES);
      registerStationPlaces(stations.STATION_PLACES);
    })
    .catch((error) => {
      // 청크 로드 실패(오프라인 등) — 역 없이도 도시·구·랜드마크 해석은 된다. 다음 호출에서 재시도.
      pending = null;
      console.warn("[station-places] load failed:", error);
    });
  return pending;
}
